<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M1078 1181 c-65 -36 -117 -68 -118 -71 0 -3 17 -14 38 -25 20 -11 37
-26 37 -32 0 -27 -96 -144 -215 -264 -215 -216 -397 -313 -662 -354 -34 -5
-38 -9 -38 -37 l0 -31 60 7 c309 35 622 242 867 573 30 40 56 73 59 73 3 0 25
-12 50 -26 l44 -26 0 141 c0 78 -1 141 -2 140 -2 -1 -56 -31 -120 -68z"
      />
      <path
        d="M128 1104 c-5 -4 -8 -151 -8 -327 l0 -320 53 7 c105 14 97 2 97 137
l0 119 49 0 c75 0 88 -20 93 -133 l3 -59 65 34 c63 32 65 35 68 75 4 58 -20
111 -59 127 l-33 14 32 16 c44 22 62 63 62 136 0 84 -20 123 -78 152 -40 19
-67 23 -192 26 -80 2 -148 1 -152 -4z m257 -108 c13 -9 20 -30 23 -69 4 -50 2
-58 -21 -81 -20 -20 -36 -26 -72 -26 l-45 0 0 95 0 95 48 0 c27 0 56 -6 67
-14z"
      />
      <path
        d="M680 900 l0 -212 75 68 76 67 -3 141 -3 141 -72 3 -73 3 0 -211z"
      />
      <path
        d="M997 834 c-4 -4 -7 -179 -7 -389 0 -283 3 -384 12 -393 17 -17 142
-16 157 2 8 9 10 122 9 397 l-3 384 -80 3 c-45 1 -84 0 -88 -4z m133 -389 l0
-365 -50 0 -50 0 0 358 c0 197 3 362 7 365 3 4 26 7 50 7 l43 0 0 -365z"
      />
      <path
        d="M706 535 c-12 -32 -7 -470 6 -483 7 -7 42 -12 85 -12 67 0 73 2 78
22 3 13 4 127 3 253 l-3 230 -81 3 c-68 2 -83 0 -88 -13z m134 -235 l0 -220
-50 0 -50 0 0 220 0 220 50 0 50 0 0 -220z"
      />
      <path
        d="M421 381 c-16 -29 -14 -303 2 -325 10 -14 25 -16 87 -14 l75 3 0 175
0 175 -77 3 c-68 2 -78 1 -87 -17z m129 -161 l0 -140 -50 0 -50 0 0 140 0 140
50 0 50 0 0 -140z"
      />
      <path
        d="M215 302 c-101 -5 -95 3 -95 -126 0 -85 3 -116 14 -125 9 -7 42 -11
88 -9 l73 3 3 122 c3 140 3 140 -83 135z m53 -129 l3 -93 -56 0 -55 0 0 88 c0
49 3 92 7 96 4 4 28 6 53 4 l45 -3 3 -92z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
